import styled from "styled-components";

const DraggableListStyled = styled.div`

`

export default DraggableListStyled;